

/** @TopControlsController */
/* global Modernizr */

const _ = require('lodash');

function TopControlsController(
  $scope,
  $http,
  $timeout,
  $state,
  $location,
  $window,
  $element,
  Utils,
  Flux,
  SiteSelectorActions,
  DataCaptureSelectorActions,
  InviteToSiteActions,
  TopControlsActions,
  DashDialogsActions,
  AppDialogsActions,
  NavStore,
  NavActions,
  IntercomService,
  IdentityService,
  AnalyticsService,
  OrganizationStore,
  SaturnGrowl,
  DataCaptureSelectorStore,
  IngestorService,
  DropdownService
) {

  const SiteStore = Flux.Store.get('SiteStore');
  const TopControlsStore = Flux.Store.get('TopControlsStore');
  const PdfStore = Flux.Store.get('PdfPreviewStore');
  const MapStore = Flux.Store.get('MapStore');
  const WebglMapStore =  Flux.Store.get('WebglMapStore');
  const PlanStore = Flux.Store.get('PlanStore');

  const vm = this;
  const supportSite = '//support.skycatch.com/hc/en-us/categories/201644828-Skycatch-Dashboard';
  const uploaderSite = IdentityService.get('uploadUrl');
  const user = IdentityService.get('user');
  const deviceAgent = navigator.userAgent.toLowerCase();
  vm.useMapboxGLRenderer = TopControlsStore.get('useMapboxGL') || false;

  let uploaderToken = '';

  // default state
  vm.currentSite = SiteStore.get('current') ? SiteStore.get('current').name : 'Loading...';
  vm.hasMultipleOrganizations = user && user.organizations ? user.organizations.length > 1 : false;
  vm.showLabel = true;
  vm.isProtected = true;
  vm.disableWorkmode = false;
  vm.modernizrAvailable = typeof Modernizr !== 'undefined';
  vm.modernizrTouch = Modernizr.touch && (deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i));
  vm.incompatibleBrowserTrigger = true;
  vm.notSupportedInPlan3d = true;
  vm.showIncompatibiltyDialog = false;
  vm.plan = PlanStore.get('orgPlan');
  vm.canPlanChat = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  vm.hasEnabledPlan = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled;
  vm.isBetaUser = IdentityService.isBetaUser();
  vm.isIngestorUser = IdentityService.isIngestBetaUser();

  vm.betaFeatures = IdentityService.getBetaFeatures();
  vm.showDataViewDropdown = false;
  vm.disableMeshMap = false;
  vm.disablePointCloudMap = false;
  vm.orthoOnly = false;
  vm.isEditing = false;
  vm.supportsWebGL = (() => {
    try {
      return !!window.WebGLRenderingContext && !!document.createElement('canvas').getContext('experimental-webgl');
    }
    catch (e) {
      return false;
    }
  })();

  /**
   * Fix styles on iOS browsers
   */
  if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
    document.body.classList.add('safari-mobile');
  }

  /**
   * Show/Hide the correct viewer for the format dropdown
   */
  vm.toggleMapViewer = (layerType) => {

    const types = {
      'tileLayer' : '2D Ortho Map',
      'mesh_gltf' : '3D Mesh',
      'pc_rgb'    : '3D Point Cloud'
    };
    vm.dataViewType = layerType;
    vm.dataViewLabel = types[layerType];
    vm.showDataViewDropdown = false;
    vm.currentDataView = vm.dataViews[layerType];

    TopControlsActions.ToggleWebglMap.dispatch(layerType);
  };

  vm.dataViews = {
    tileLayer: {
      type: 'tileLayer',
      label: '2D Ortho Map',
      icon: 'fa-icon-2d-ortho',
      disable: false,
      fn: vm.toggleMapViewer.bind(vm, 'tileLayer')
    },
    pc_rgb: {
      type: 'pc_rgb',
      label: '3D Point Cloud',
      icon: 'fa-icon-point-cloud',
      disable: vm.disablePointCloudMap,
      fn: vm.toggleMapViewer.bind(vm, 'pc_rgb')
    },
    mesh_gltf: {
      type: 'mesh_gltf',
      label: '3D Mesh',
      icon: 'fa-icon-3d-mesh',
      disable: vm.disableMeshMap,
      fn: vm.toggleMapViewer.bind(vm, 'mesh_gltf')
    }
  };

  vm.visibleChildren = {};
  vm.someChildrenHidden = false;

  vm.onChildHide = (newChildStatus) => {
    vm.visibleChildren = _.reduce(newChildStatus, (res, child) => {
      res[child.id] = child.visible;
      return res;
    }, {});

    vm.someChildrenHidden = _.some(vm.visibleChildren, (child) => {
      return !child;
    });
  };

  /* custom logo */
  vm.brandConfig = OrganizationStore.getBrandConfig();
  /* /custom logo */

  /**
   * Handler to open the Intercom Chat window
   */
  vm.openChat = () => {

    IntercomService.show();
    DropdownService._closeGroup('topnav')
  };

  vm.openSupport = () => {

    $window.open(supportSite, '_blank');
  };

  vm.openSettings = () => {

    $state.go('settings.myProfile');
  };

  vm.changeOrg = () => {

    $state.go('select-organization');
  };

  /**
   * Handler for the UserStore change, to fetch available sites for the current user
   */
  vm.showSiteSelector = () => {

    if (vm.isEditing) {
      TopControlsActions.ChangeNavigationWhileDisabled.dispatch('siteSelector');
      return;
    }

    SiteSelectorActions.ShowSiteSelector.dispatch();

  };

  vm.toggleNewestDatacapture = () => {

    DataCaptureSelectorActions.NewestDatacapture.dispatch();
  };

  vm.convertToSubscription = () => {
    window.open('https://www.skycatch.com/pricing/#contact_form', '_blank')
    // Disabled
    // const subscription = PlanStore.get('externalSubscription');
    // AnalyticsService.track('[CORE] Subscription', 'Enter Flow', {
    //   'remaining_days': (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24),
    //   'state': $state.current.name
    // });
    // AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  vm.updateUploaderUrl = () => {

    const url = IdentityService.getAuthApiUri() + '/sso';

    const httpConfig = {
      url,
      method: 'POST'
    };

    return $http(httpConfig)
      .then((payload) => {
        const data = payload.data.data;
        if (data && data.token) {
          uploaderToken = data.token;
        }
      })
      .catch((payload, status) => {
        console.warn('SSO fetch failed', payload, status);
      });
  };

  vm.toggleUploader = _.debounce(() => {

    if (vm.isIngestorUser) {
      $state.go('uploader')
    }
    else {
      let url;

      if (uploaderToken) {
        url = uploaderSite + 'login?token=' + uploaderToken + '&orgId=' + IdentityService.get('currentOrganization').id;
      }
      else {
        url = uploaderSite;
      }
      $window.open(url, '_blank');
    }
  }, 0);


  vm.showInviteToSite = () => {

    if (vm.isEditing) {
      TopControlsActions.ChangeNavigationWhileDisabled.dispatch();
      return;
    }
    const subscription = PlanStore.get('externalSubscription');
    if (subscription && subscription.status === 'cancelled' || !vm.hasEnabledPlan) {
      AnalyticsService.track('[CORE] Subscription', 'Invite - Disabled Plan', {});
      AppDialogsActions.MustBePayingCustomer.dispatch();
      return;
    }
    InviteToSiteActions.InviteToSite.dispatch();
  };

  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Handler for clicking the show hide switch for 3d map
   */
  vm._toggleWebglMap = () => {

    // browser compat http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;
    // alert for incompatible browser
    if (isIE || isEdge || !Modernizr.webgl) {
      return;
    }
    vm.incompatibleBrowserTrigger = false;
    vm.notSupportedInPlan3d = false;
  };

  vm.toggleMapboxGLRenderer = () => {

    vm.useMapboxGLRenderer = !vm.useMapboxGLRenderer;

    if (vm.useMapboxGLRenderer) {
      AnalyticsService.track('[CORE] MapboxGL', 'Switch to MapboxGL', {});
    }

    TopControlsActions.ToggleMapboxGL.dispatch(vm.useMapboxGLRenderer);
  };

  vm.disableMapboxGL = () => {

    vm.mapboxGLTooltip = vm.getMapboxGLTooltip();

    return vm.isEditing || !vm.supportsWebGL;
  };

  vm.getMapboxGLTooltip = () => {

    let msg = '';

    if (vm.isEditing) {
      msg = 'Switching map mode disabled while editing';
    }
    else if (!vm.supportsWebGL) {
      msg = 'To use this feature, make sure your browser supports WebGL.';
    }

    return msg;
  };

  vm.showNotFeatureEnabled3d = () => {

    vm.showNotFeatureEnabled3d = true;
    $element[0].querySelector('.webgl-incompatibility-dialog').style.height = $window.innerHeight + 'px';
  };

  vm.showIncompatibiltyDialogTrigger = () => {

    vm.showIncompatibiltyDialog = true;
    $element[0].querySelector('.webgl-incompatibility-dialog').style.height = $window.innerHeight + 'px';
  };

  vm.closeIncompatibiltyModal = () => {

    vm.showIncompatibiltyDialog = false;
  };

  /**
   * Handler for the UserStore change, updates the current Site label
   */
  vm._handleSiteStoreChange = () => {

    const currentSite = SiteStore.get('current');

    if (currentSite && currentSite.project) {
      vm.isProtected = currentSite.project.protected;
      if (PlanStore.get('current')) {
        if (PlanStore.get('current').organizationId !== IdentityService.get('currentOrganization').id) {
          vm.isProtected = true;
        }
      }
      else {
        vm.isProtected = true;
      }

      vm.currentSite = currentSite.name;
    }

    TopControlsActions.ToggleWebglMap.dispatch(false);

    // lets update the autohide
    vm.updateAutohideLayout();
  };


  vm._handlePlanStoreChange = _.debounce(() => {

    const customer = PlanStore.get('externalCustomer');
    const subscription = PlanStore.get('externalSubscription');
    vm.hasEnabledPlan = PlanStore.get('orgPlan').isEnabled;
    if (subscription) {
      vm.daysLeft = (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24);
      if (subscription.status === 'in_trial' && customer.card_status !== 'valid') {
        vm.planUpsellState = true;
      }
      else if (subscription.status === 'cancelled') {
        vm.daysLeft = 0;
        vm.planUpsellState = true;
      }
      else {
        vm.planUpsellState = false;
      }
    }
    IngestorService.sendHideTopbarWidget()
    IngestorService.sendShowTopbarWidget()
    vm.canPlanChat = PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
    vm._handleSiteStoreChange();
  }, 900);

  /**
   * Handler for the our component store change, updates the current 3d toggle state
   */
  vm._handleTopControlsStoreChange = () => {

    vm.disablePointCloudMap = TopControlsStore.get('disablePointCloudMap');
    vm.disableMeshMap = TopControlsStore.get('disableMeshMap');
    vm.disableNewest = TopControlsStore.get('disableNewest');
    vm.showWebglMap = TopControlsStore.get('showWebglMap');

    if (vm.disablePointCloudMap && vm.disableMeshMap) {
      vm.orthoOnly = true;
    }
    else {
      vm.orthoOnly = false;
    }

    vm.dataViews.pc_rgb.disable = vm.disablePointCloudMap;
    vm.dataViews.mesh_gltf.disable = vm.disableMeshMap;

    vm.updateAutohideLayout();
  };

  vm._handleAutodeskProcessingFinished = () => {

    SaturnGrowl.newGrowl('Your PDF has been successfully saved in Autodesk BIM 360.', {
      id: 'pdf-ready',
      time: 20000
    });
  };

  vm._handleClearDownload = () => {

    SaturnGrowl.removeGrowl({
      id: 'pdf-ready'
    });
  };

  vm.resetPage = () => {

    if (vm.isEditing) {
      TopControlsActions.ChangeNavigationWhileDisabled.dispatch('/');
      return;
    }

    $location.path('/');

  };

  vm._handleEditBegin = () => {

    vm.isEditing = true;
  };

  vm._handleEditEnd = () => {

    vm.isEditing = false;
  };

  /**
   * Handler for the Logout action, clears the localstorage, cookies and reloads the page
   */
  vm.logout = () => {

    if (vm.isEditing) {
      TopControlsActions.ChangeNavigationWhileDisabled.dispatch('/logout');
      return;
    }

    $state.go('logout', {}, {
      location: false
    });

  };

  vm._handleWebglMapStoreChange = () => {

    if (!(WebglMapStore.get('active'))) {
      vm.currentDataView = vm.dataViews.tileLayer;
      vm.dataViewLabel = vm.dataViews.tileLayer.label;
    }

    TopControlsActions.ChangeCurrentLayerType.dispatch(vm.currentDataView.type);

    vm.disablePointCloudMap = TopControlsStore.get('disablePointCloudMap');
    vm.disableMeshMap = TopControlsStore.get('disableMeshMap');
    vm.disableNewest = TopControlsStore.get('disableNewest');
    vm.showWebglMap = TopControlsStore.get('showWebglMap');
  };

  vm.updateAutohideLayout = () => {

    $timeout(() => {

      // we need to give angular a tick to show or hide its elements based on the site permissions
      $scope.$broadcast('RELOAD_AUTOHIDE');
    });

  };

  // init
  vm.updateUploaderUrl();
  vm._handlePlanStoreChange(); // Needed to show growlers / set plan related info
  // Bindings
  SiteStore.on(SiteStore.Events.Changed, vm._handleSiteStoreChange.bind(vm), $scope);
  TopControlsStore.on(TopControlsStore.Events.Changed, vm._handleTopControlsStoreChange.bind(vm), $scope);
  PdfStore.on(PdfStore.Events.AutodeskSynced, vm._handleAutodeskProcessingFinished.bind(vm), $scope);
  MapStore.on(MapStore.Events.ClearDownload, vm._handleClearDownload.bind(vm), $scope);
  NavStore.on(NavStore.Events.IsEditing, vm._handleEditBegin.bind(vm), $scope);
  NavStore.on(NavStore.Events.FinishedEditing, vm._handleEditEnd.bind(vm), $scope);
  PlanStore.on(PlanStore.Events.Changed, vm._handlePlanStoreChange.bind(vm), $scope);
  WebglMapStore.on(WebglMapStore.Events.Changed, vm._handleWebglMapStoreChange.bind(vm), $scope);
  DataCaptureSelectorStore.on(DataCaptureSelectorStore.Events.Loaded, vm.updateAutohideLayout.bind(vm), $scope);
  $scope.$watch('topControlsCtrl.showWebglMap', vm._toggleWebglMap.bind(vm));
}

TopControlsController.$inject = [
  '$scope',
  '$http',
  '$timeout',
  '$state',
  '$location',
  '$window',
  '$element',
  'Utils',
  'sbFlux',
  'SiteSelectorActions',
  'DataCaptureSelectorActions',
  'InviteToSiteActions',
  'TopControlsActions',
  'DashDialogsActions',
  'AppDialogsActions',
  'NavStore',
  'NavActions',
  'IntercomService',
  'IdentityService',
  'AnalyticsService',
  'OrganizationStore',
  'SaturnGrowl',
  'DataCaptureSelectorStore',
  'IngestorService',
  'DropdownService'
];

module.exports = TopControlsController;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/TopControlsController.js